import classNames from 'classnames';

import { CancelReason } from '../../../../../../types/hubInterfaces';

const checkedWhiteTickStyle = {
  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#ffffff' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round' d='M3 9l4.25 4.25L13.5 3'/></svg>"
  )}")`,
  backgroundSize: '13px 13px',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
} as const;

interface Props {
  checked: boolean;
  onCheck(reason: CancelReason): void;
  reason: CancelReason;
  additionalInfo?: React.ReactNode;
}

const ReasonCheckbox = ({ reason, checked, onCheck, additionalInfo }: Props) => {
  return (
    <>
      <div key={reason.label} className="flex items-center gap-x-3">
        <div className="shrink-0">
          <input
            type="checkbox"
            id={reason.label}
            onChange={() => onCheck(reason)}
            checked={checked}
            style={checked ? checkedWhiteTickStyle : undefined}
            className={classNames(
              'h-[18px] w-[18px] shrink-0 cursor-pointer appearance-none rounded border-2 border-grey-3 bg-white',
              'checked:border-blood-orange-4 checked:bg-blood-orange-4',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-4/40 focus-visible:ring-offset-2'
            )}
          />
        </div>
        <div className="flex flex-col gap-y-1">
          <label
            className={classNames('cursor-pointer text-sm', checked ? '!font-semibold' : '!font-normal')}
            htmlFor={reason.label}
          >
            {reason.label}
          </label>
        </div>
      </div>

      {additionalInfo && <div>{additionalInfo}</div>}
    </>
  );
};

export default ReasonCheckbox;
